import { Children, memo, type JSX } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, EffectFade } from 'swiper/modules';
import { createGlobalStyle } from 'styled-components';

const SiteSwiperGlobalStyle = createGlobalStyle`
  .swiper-button-prev,
  .swiper-button-next {
    transition: opacity .25s ease;
    opacity: 0;
  }

  .swiper-pagination {
    text-align: center;

    .swiper-pagination-bullet {
      display: inline-block;
      height: 5px;
      width: 5px;
      margin: 3.5px;
      border-radius: 5px;
      background: #1c3a13cc;
      border: none;
      &.swiper-pagination-bullet-active {
        background: var(--fill-brand);
      }
    }
  }
`;

type SiteSwiperProps = {
  children: JSX.Element | JSX.Element[];
  params: Record<string, any>;
  onChange?: (activeIndex: any) => void; //
} & Record<string, any>;

const SiteSwiper = memo(
  ({ children, params, onChange, ...rest }: SiteSwiperProps) => {
    const combinedParams: {
      modules: any[];
      autoHeight: boolean;
      pagination: { clickable?: boolean };
      onClick?: (e: any) => void;
      onSlideChange?: (activeIndex: any) => void;
    } = {
      modules: [Pagination, EffectFade],
      autoHeight: true,
      pagination: {},
      ...params,
      ...rest,
    };

    if (combinedParams?.pagination?.clickable === true) {
      combinedParams.onClick = (e) => {
        e.slideNext();
      };
    }
    if (onChange) {
      combinedParams.onSlideChange = onChange;
    }

    return (
      <Swiper {...combinedParams}>
        <SiteSwiperGlobalStyle />
        {Children.map(children, (child) => (
          <SwiperSlide>{child}</SwiperSlide>
        ))}
        <div className='swiper-pagination' />
      </Swiper>
    );
  },
);

export default SiteSwiper;
